import dataChangedCount from '@/utils/dataChangedCount'


export default {
  data() {
    return {
      querySelected: 0
    }
  },
  watch: {
    queryRequest: {
      handler(newValue, oldValue) {
        this.querySelected = dataChangedCount(this,'queryRequest')
      },
      deep: true
    }
  }
}
